export default __webpack_public_path__ + "static/media/FinanceRealCase2.3547d91c.jpg";